import { useEffect, useState } from 'react';
import { noteBootAuthedApiReady } from '../lib/bootWarmupSignals';
import { runAuthedApiProbe } from '../lib/authedApiProbe';

/**
 * Runs the authed-API probe once per signed-in session. Keyed on a boolean (not the token
 * string) so a token rotation mid-probe neither cancels nor restarts it.
 * Returns 'pending' | 'ok' | 'failed'.
 */
export function useAuthedApiProbe(auth) {
  const [state, setState] = useState('pending');
  const hasToken = !!auth?.accessToken;
  const eligible = !!auth?.isAuthenticated && hasToken && !auth?.isLoading;

  useEffect(() => {
    setState('pending');
    if (!eligible) {
      noteBootAuthedApiReady(false);
      return undefined;
    }
    let cancelled = false;
    runAuthedApiProbe(() => cancelled).then((result) => {
      if (result === 'cancelled') return;
      noteBootAuthedApiReady(result === 'ok');
      setState(result);
    });
    return () => { cancelled = true; };
  }, [eligible]);

  return state;
}
